import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';
import { AROrgeCampaign, AROrgeCampaignConfiguration } from '../../../../models/agrorendement-orge.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { AROrgeService } from '../../../../services/agrorendement-orge.service';
import { correctDate, showErrorMessage } from '../../../../utils/utils';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  standalone: true,
  selector: 'ar-orge-campaign-config-edit',
  templateUrl: 'campaign-config-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CampaignYearPipe, TranslatePipe, CommonModule, FormsModule, BsDatepickerModule],
  providers: [AROrgeService],
})
export class AROrgeCampaignConfigurationEditComponent implements OnInit, OnDestroy {
  @Input() config: AROrgeCampaignConfiguration;
  @Output() close = new EventEmitter();
  error: any;
  sub: any;

  edited = false;

  configId: number;
  isStartingOnCollapsed: boolean = false;
  isOrderT1EndingOnCollapsed: boolean = false;
  isDataT1EndingOnCollapsed: boolean = false;
  isOrderT2EndingOnCollapsed: boolean = false;
  isDataT2EndingOnCollapsed: boolean = false;
  isOrderT3EndingOnCollapsed: boolean = false;
  isDataT3EndingOnCollapsed: boolean = false;
  campaign: AROrgeCampaign;

  constructor(
    private orgeService: AROrgeService,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  goBack(savedConfig: AROrgeCampaignConfiguration = null) {
    this.close.emit(savedConfig);
    this.router.navigate(['/orders', 'azote', 'orge', 'admin']);
    return false;
  }

  save() {
    if (this.config.startingOn) {
      this.config.startingOn = correctDate(<Date>this.config.startingOn);
    }

    if (this.config.orderT1EndingOn) {
      this.config.orderT1EndingOn = correctDate(<Date>this.config.orderT1EndingOn);
    }

    if (this.config.dataT1EndingOn) {
      this.config.dataT1EndingOn = correctDate(<Date>this.config.dataT1EndingOn);
    }

    if (this.config.orderT2EndingOn) {
      this.config.orderT2EndingOn = correctDate(<Date>this.config.orderT2EndingOn);
    }

    if (this.config.dataT2EndingOn) {
      this.config.dataT2EndingOn = correctDate(<Date>this.config.dataT2EndingOn);
    }

    if (this.config.orderT3EndingOn) {
      this.config.orderT3EndingOn = correctDate(<Date>this.config.orderT3EndingOn);
    }

    if (this.config.dataT3EndingOn) {
      this.config.dataT3EndingOn = correctDate(<Date>this.config.dataT3EndingOn);
    }

    this.orgeService.saveCampaignConfiguration(this.config).subscribe(
      (config) => {
        this.config = config;
        this.goBack(config);
      },
      (error) => this.handleSaveError(error),
    );
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      if (this.route.snapshot.url[4].path === 'new') {
        this.edited = false;
        this.config = new AROrgeCampaignConfiguration();
        this.config.campaign = new AROrgeCampaign();
        if (params['campaignId']) {
          this.config.campaign.id = +params['campaignId'];
          this.getCampaign(this.config.campaign.id);
        } else {
          showErrorMessage(this.modal, 'Pas de campagne spécifiée').then((r) => {
            this.router.navigate(['/orders', 'azote', 'orge', 'admin']);
          });
        }
        this.isStartingOnCollapsed = true;
        this.isOrderT1EndingOnCollapsed = true;
        this.isDataT1EndingOnCollapsed = true;
        this.isOrderT2EndingOnCollapsed = true;
        this.isDataT2EndingOnCollapsed = true;
        this.isOrderT3EndingOnCollapsed = true;
        this.isDataT3EndingOnCollapsed = true;
      } else if (this.route.snapshot.url[4].path === 'edit') {
        this.configId = +params['configId'];
        this.edited = true;
        // FIXME traiter les erreurs ; afficher un message
        this.orgeService.getCampaignConfiguration(this.configId).subscribe(
          (config) => {
            this.config = config;
            this.campaign = config.campaign;
          },
          (e) => this.handleGetError(e),
        );
      }
    });
  }

  getCampaign(campaignId: number) {
    this.orgeService.getCampaign(campaignId).subscribe(
      (campaign) => {
        this.campaign = campaign;
      },
      (error) => this.handleGetError(error),
    );
  }

  handleSaveError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette configuration");
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, 'Il y a des erreurs dans le formulaire');
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à consulter cette configuration").then((r) => {
        this.router.navigate(['/orders', 'azote']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, 'Une erreur est survenue').then((r) => {
        this.router.navigate(['/orders', 'azote', 'orge', 'admin']);
      });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
